import { render, staticRenderFns } from "./helathSuggest.vue?vue&type=template&id=11d2b7ae&scoped=true&"
import script from "./helathSuggest.vue?vue&type=script&lang=js&"
export * from "./helathSuggest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.10.1_942d38e42bf4b987e783635c88cde9fa/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11d2b7ae",
  null
  
)

export default component.exports